import React, { Component } from "react";

import FormsRow from "./FormsRow";
import { main_url } from "../../../../utils/CommonFunction";

export default class FileInput extends Component {
  render() {
    const oldDocs = this.props.oldDocs;
    const newDocs = this.props.newDoc;

    return (
      <>
        <FormsRow className="margin-top-20">
          <div className="col-md-12 btn-rightend">
            <input
              className="dropZone "
              type="file"
              id="petrolCRDrop"
              multiple
              onChange={this.props.onFileChanged}
            ></input>
          </div>
        </FormsRow>
        <FormsRow className="margin-top-20">
          {oldDocs &&
            oldDocs.map((data, index) => (
              <div key={data.name} className="fileuploader-items col-md-4">
                <ul className="fileuploader-items-list">
                  <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                    <div className="columns">
                      <div className="column-title">
                        <a
                          href={`${main_url}api/v1/petrol/petrol-request/getCRDocumentData/${data.name}`}
                          download
                          target="_blank"
                          className="btn btn-primary document-body-bt document-width"
                        >
                          {data.name}
                        </a>
                      </div>
                      <div className="column-actions">
                        <a
                          className="fileuploader-action fileuploader-action-remove"
                          onClick={(event) =>
                            this.props.onRemoveOldDocument(index, event)
                          }
                        >
                          {" "}
                          <i></i>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            ))}
          {newDocs &&
            newDocs.map((data, index) => (
              <div key={data.name} className="fileuploader-items col-md-4">
                <ul className="fileuploader-items-list">
                  <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                    <div className="columns">
                      <div className="column-thumbnail">
                        <div className="fileuploader-item-image fileuploader-no-thumbnail">
                          <div
                            className="fileuploader-item-icon"
                            style={{ backgroundColor: "#3f4fd3" }}
                          >
                            <i>{data.name.split(".")[1]}</i>
                          </div>
                        </div>
                        <span className="fileuploader-action-popup"></span>
                      </div>
                      <div className="column-title">
                        <span className="own-text">{data.name}</span>
                      </div>
                      <div className="column-actions">
                        <a
                          className="fileuploader-action fileuploader-action-remove"
                          onClick={(event) =>
                            this.props.onRemoveDocument(index, event)
                          }
                        >
                          {" "}
                          <i></i>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            ))}
        </FormsRow>
      </>
    );
  }
}
